import { DialogContent } from './ui/DialogContent';
import React from 'react';
import { TextField, Button, MenuItem } from '@mui/material';
import { ResponsiveDialog } from './ui/ResponsiveDialog';
import { DialogHeader } from './ui/DialogHeader';
import { DialogActions } from './ui/DialogActions';

interface AddLocationModalProps {
  open: boolean;
  onClose: () => void;
  newLocation: string;
  setNewLocation: (value: string) => void;
  newLocationDescription: string;
  setNewLocationDescription: (value: string) => void;
  locationError: string | null;
  handleAddLocation: () => Promise<void>;
  collectionOptions?: Array<{ collectionId: string; name: string }>;
  collectionId?: string;
  onCollectionChange?: (collectionId: string) => void;
}

const AddLocationModal: React.FC<AddLocationModalProps> = ({
  open,
  onClose,
  newLocation,
  setNewLocation,
  newLocationDescription,
  setNewLocationDescription,
  locationError,
  handleAddLocation,
  collectionOptions,
  collectionId,
  onCollectionChange,
}) => {
  return (
    <ResponsiveDialog
      open={open}
      onClose={onClose}
      aria-labelledby="add-location-title"
    >
      <DialogHeader
        id="add-location-title"
        title="Add New Location"
        onClose={onClose}
      />
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        {collectionOptions && collectionOptions.length > 1 && (
          <TextField
            select
            required
            label="Add to collection"
            value={collectionId || ''}
            onChange={(event) => onCollectionChange?.(event.target.value)}
            fullWidth
          >
            {collectionOptions.map((collection) => (
              <MenuItem
                key={collection.collectionId}
                value={collection.collectionId}
              >
                {collection.name}
              </MenuItem>
            ))}
          </TextField>
        )}
        <TextField
          label="Location Name"
          value={newLocation}
          onChange={(e) => setNewLocation(e.target.value)}
          fullWidth
          error={!!locationError}
          helperText={locationError}
        />
        <TextField
          label="Description"
          value={newLocationDescription}
          onChange={(event) => setNewLocationDescription(event.target.value)}
          fullWidth
          multiline
        />
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={handleAddLocation}
          disabled={Boolean(collectionOptions && !collectionId)}
        >
          Add Location
        </Button>
      </DialogActions>
    </ResponsiveDialog>
  );
};

export default AddLocationModal;
